import { render, staticRenderFns } from "./timeCost.vue?vue&type=template&id=4650ce7a&scoped=true"
import script from "./timeCost.vue?vue&type=script&lang=js"
export * from "./timeCost.vue?vue&type=script&lang=js"
import style0 from "./timeCost.vue?vue&type=style&index=0&id=4650ce7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4650ce7a",
  null
  
)

export default component.exports